module.exports = __webpack_public_path__ + "static/fonts/fzh.6934e4e3.ttf";